import * as React from 'react';
import { Prompt } from 'react-router';
import { Link } from 'react-router-dom';
import { Card } from 'material-ui/Card';
import { get } from 'lodash';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { compose, withProps } from 'recompose';
import { reduxForm } from 'redux-form';
import { Input, InputField, ToggleField, Toggle, RemoteAutoCompleteField, RemoteAutoComplete } from '@components/form';

import * as T from '@modules/hr-shifts/_shiftsTypes';
import EntityDetailEnhancer from '@components/hoc/entityDetailEnhancer/EntityDetailEnhancer';
import { getShift } from '@modules/hr-shifts/_shiftsActions';
import { required, isNumber } from '@utils/validators';
import { shiftsPath } from './ShiftsGrid';

const enhance = compose<T.ShiftsFormProps, T.ShiftsFormProps>(
  EntityDetailEnhancer<T.ShiftsEnhancerProps<T.Shift>, T.Shift>({
    getEntity: getShift,
    defaultEntity: {}
  }),
  breadcrumbs(({ entity }) => [{ label: 'Směny', to: shiftsPath }, { label: get(entity, 'name', 'Nová směna') }]),
  withProps<{}, T.ShiftsForm>(({ entity }) => ({
    initialValues: get(entity, 'id') ? entity : {}
  })),
  reduxForm({
    form: 'shiftsForm'
  })
);

const View: React.SFC<T.ShiftsFormProps> = ({ selectedCalendar, change, ...props }) => (
  <div>
    <Prompt
      when={props.dirty && !props.submitSucceeded && !props.submitting}
      message="Vaše změny nebyly uloženy, přesto odejít?"
    />
    <form className="layout" onSubmit={props.handleSubmit}>
      <Card>
        <Grid fluid={true}>
          <Row>
            <Col className="grid-system-margin" />
          </Row>
          <Row>
            <Col md={4} xl={2} className="with-right-divider">
              <Row>
                <Col md={12}>
                  <h4>Základní údaje</h4>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <InputField component={Input} name="name" label="Název *" validate={[required]} />
                </Col>
                <Col md={12}>
                  <InputField component={Input} name="order" label="Pořadí" validate={[isNumber]} />
                </Col>
                <Col md={12}>
                  <ToggleField
                    component={Toggle}
                    name="active"
                    label="Aktivní"
                    labelPosition="right"
                    onToggle={(_, value) => {
                      change('active', value);
                    }}
                    style={{ marginTop: 24 }}
                  />
                </Col>
                <Col md={12}>
                  <RemoteAutoCompleteField
                    component={RemoteAutoComplete}
                    name="station"
                    label="Pracoviště"
                    url={`/metropolis/api/ed/stations/all`}
                    labelFunction={o => get(o, 'name')}
                    valueFunction={o => o}
                    fullWidth={true}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Grid>

        <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} containerElement={<Link to={shiftsPath} />} />
      </Card>
    </form>
  </div>
);

export const ShiftsForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/hr-shifts/ShiftsForm.tsx